import { render } from "./cloudEnabled.vue?vue&type=template&id=124c6963&scoped=true"
import script from "./cloudEnabled.vue?vue&type=script&lang=js"
export * from "./cloudEnabled.vue?vue&type=script&lang=js"

import "./cloudEnabled.vue?vue&type=style&index=0&id=124c6963&lang=scss&scoped=true"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-124c6963"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QIcon});
